// extracted by mini-css-extract-plugin
export default {"fullMaxWidth":"uN-z","carouselContainer":"vN-z"};